import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ROUTES} from "../../../routes";
import {useHistory} from "react-router-dom";

import {
  clearWizardSelectedValue,
  setWizardConflictPopupOpened,
} from "../../../actions/wizardFunctions";
import {addToCart, removeFromCart, toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import {useChangeWizardStepRoute} from "../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {getCartItemObject} from "../../../misc/helpers";
import {renderConfirmPopup} from "../../../api/api-popups";
import {getNextWizardSteps} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {getCurrentGroups} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";

const WizardConflictPopupButtons = (props) => {

  const {setWizardConflictPopupOpened, removeFromCart, selectionFeatureInfo, toggleSelectionFeatureInfo,
    wizardSelectedValues, wizardActiveStep, hideOverlay, cartItemsToRemove, fabricatorSettings, addToCart,
    selectionInfoQuantity, qtActiveCategory, showAdvancedQuoting, confirmPopupTag, clearWizardSelectedValue,
    wizardList, wizardIsActive, advancedQuotingSearchItem, selectionOpened, wizardActiveItem} = props;

  const {changeWizardStepRoute} = useChangeWizardStepRoute();
  let history = useHistory();

  // console.log("cartItemsToRemove", cartItemsToRemove);

  const closePopup = (runDeclineFunc = true) => {
    if (confirmPopupTag.declineFunction && runDeclineFunc) {
      confirmPopupTag.declineFunction();
      renderConfirmPopup(0, {}, false); // clear tag
    }
    hideOverlay(() => {
      setWizardConflictPopupOpened(false)
    });
  }

  const applyClick = () => {

    cartItemsToRemove.forEach(cartItem => {
      removeFromCart(cartItem);
    });
    if (showAdvancedQuoting) {
      if (wizardIsActive && wizardList) {
        cartItemsToRemove.forEach(cartItem => {
          if (cartItem.fromWizardStep && (cartItem.fromWizardStep === confirmPopupTag.stepIndexClicked)) {
            return
          }
          if (cartItem.fromWizardGroupId && cartItem.fromWizardStep && wizardSelectedValues
            && wizardSelectedValues[cartItem.fromWizardStep]
            && wizardSelectedValues[cartItem.fromWizardStep].selectedFeature
            && wizardSelectedValues[cartItem.fromWizardStep].selectedFeature.dbFeature.id === cartItem.cartFeature.dbFeature.id) {
            const wizardItem = wizardList.find(wizardItem => wizardItem.id === cartItem.fromWizardId);
            if (wizardItem) {
              let newWizardSteps = getNextWizardSteps(wizardItem, cartItem.fromWizardStep, wizardSelectedValues);
              if (newWizardSteps[cartItem.fromWizardStep] && newWizardSteps[cartItem.fromWizardStep].stepGroups
                && newWizardSteps[cartItem.fromWizardStep].stepGroups.length === 1) {
                console.log("clear step", wizardSelectedValues[cartItem.fromWizardStep]);
                clearWizardSelectedValue(cartItem.fromWizardStep, wizardItem, cartItem.currentQuote)
              }
            }
          }
        });
      }
      if (confirmPopupTag.applyFunction) {
        confirmPopupTag.applyFunction();
        renderConfirmPopup(0, {}, false); // clear tag
      }

      closePopup(false);
      if (selectionOpened) {
        if (fabricatorSettings.checkout) {
          const quantity = selectionFeatureInfo
            ? selectionInfoQuantity || 1
            : advancedQuotingSearchItem ? advancedQuotingSearchItem.quantity : 1;
          const cartItemObject = getCartItemObject(wizardSelectedValues[wizardActiveStep].selectedFeature, quantity, qtActiveCategory);
          addToCart([cartItemObject])
        }
        history.push(ROUTES.shoppingcart);
      }
      return
    }
    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    changeWizardStepRoute(wizardActiveStep); // clear next step value
    if (selectionFeatureInfo || (currentGroups.length === 1 && currentGroups[0].skipProductInfo
      && wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].selectedFeature)) { // just in case, we should not be here
      if (fabricatorSettings.checkout) {
        const cartItemObject = getCartItemObject(selectionFeatureInfo || wizardSelectedValues[wizardActiveStep].selectedFeature, selectionInfoQuantity || 1, qtActiveCategory);
        addToCart([cartItemObject])
      }
      toggleSelectionFeatureInfo(null);
      changeWizardStepRoute(wizardActiveStep + 1);
    } else {
      toggleSelectionFeatureInfo(wizardSelectedValues[wizardActiveStep].selectedFeature);
      // changeWizardStepRoute(wizardActiveStep + 1); // do not go to the next step, go to feature info
    }
    closePopup(false);
  }

  return (
    <div className="ui-popup__footer">
      <button className="ui-button2 ui-button2--blue" onClick={() => closePopup()}>
        <FormattedMessage id="buttons.cancel"/>
      </button>
      <button className="ui-button2 ui-button2--red ui-button2--with-padding" onClick={applyClick}>
        <FormattedMessage id="quotingTool.footer.updateCartButton"/>
      </button>
    </div>
  )
}

const mapStateToProps = (store) => {
  const {wizardSelectedValues, wizardActiveStep, wizardList, wizardIsActive, wizardActiveItem} = store.wizardState;
  const {selectionFeatureInfo, selectionInfoQuantity, selectionOpened} = store.selectionState;
  const {settings} = store.fabricatorState;
  const {qtActiveCategory} = store.qtState; // why?? we are not using qt categories logic. but let it be
  const {showAdvancedQuoting} = store.advancedQuotingState;
  const {confirmPopupTag} = store.userState;
  const {advancedQuotingSearchItem} = store.advancedQuotingState;

  return {
    wizardSelectedValues,
    wizardActiveStep,
    selectionFeatureInfo,
    selectionOpened,
    fabricatorSettings: settings,
    qtActiveCategory,
    selectionInfoQuantity,
    showAdvancedQuoting,
    confirmPopupTag,
    wizardList,
    wizardIsActive,
    advancedQuotingSearchItem,
    wizardActiveItem,
  };
};
const mapDispatchToProps = {
  setWizardConflictPopupOpened,
  removeFromCart,
  toggleSelectionFeatureInfo,
  addToCart,
  clearWizardSelectedValue,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardConflictPopupButtons)
